import { useEffect } from 'react'

import { logSentry } from '@gto/sentry'

import type { AffiliateAdminLedgerResponseSchema } from '@/api/gen'

import { isAbsent, REQUIRED_MONEY_FIELDS } from './ledger-money'

const reportMissingMoney = (data: AffiliateAdminLedgerResponseSchema): void => {
  const missingFields = REQUIRED_MONEY_FIELDS.filter((field) =>
    data.rows.some((row) => isAbsent(row[field])),
  )
  if (missingFields.length === 0) {
    return
  }
  logSentry('ledger row missing required money field:', {
    fields: missingFields.join(','),
    rows: data.rows.length,
  })
}

export const useReportMissingLedgerMoney = (
  data: AffiliateAdminLedgerResponseSchema | undefined,
) => {
  useEffect(
    function reportMissingLedgerMoney() {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- async server-data arrival, not a user event: this validates freshly-arrived query data and reports missing money fields to Sentry as a data-integrity alarm. The trigger is the query resolving, not an interaction, so there is no event handler to move it into; the [data] dep fires it once per response.
      if (data === undefined) {
        return
      }
      reportMissingMoney(data)
    },
    [data],
  )
}
